import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { Toast } from 'antd-mobile'
import { queryKycStatus } from 'store/siteConfig'

// ------------------------------------
// Constants
// ------------------------------------
export const REWARD_REFER = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  DRAW_REQUEST: null,
  DRAW_SUCCESS: null,
  QUERY_RANK_LIST_REQUEST: null,
  QUERY_RANK_LIST_SUCCESS: null
}, 'REWARD_REFER')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(callAPI({
      dispatch: dispatch,
      endpoint: 'cgs/marketing/activity/luckDraw',
      method: 'POST',
      requestAction: REWARD_REFER.INIT_REQUEST,
      successAction: REWARD_REFER.INIT_SUCCESS,
      success: function(result) {
        dispatch(queryKycStatus())
        dispatch(queryRankList({ activityId: result.activityCode }))
      },
      error: function(result, msg) {
        if (result.head.code === '70419') { // 添加活动结束标识
          dispatch({
            type: REWARD_REFER.INIT_SUCCESS,
            payload: {
              overFlag: true
            }
          })
        } else {
          Toast.info(msg)
        }
      }
    }))
  }
}

export function draw(callback, errorCallback) {
  return (dispatch, getState) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/marketing/activity/luckDraw/lottery',
        method: 'POST',
        body: {
          activityCode: getState().rewardReferState.activityCode
        },
        requestAction: REWARD_REFER.DRAW_REQUEST,
        successAction: REWARD_REFER.DRAW_SUCCESS,
        success: function(result) {
          typeof callback === 'function' && callback(result)
        },
        error: function(result, msg) {
          Toast.info(msg)
          typeof callback === 'function' && errorCallback()
        }
      })
    )
  }
}

export function queryRankList(data) {
  return (dispatch, getState) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/marketing/random/reduction',
        method: 'POST',
        body: data,
        requestAction: REWARD_REFER.QUERY_RANK_LIST_REQUEST,
        successAction: REWARD_REFER.QUERY_RANK_LIST_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [REWARD_REFER.INIT_REQUEST]: (state, action) => state,
  [REWARD_REFER.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [REWARD_REFER.DRAW_REQUEST]: (state, action) => state,
  [REWARD_REFER.DRAW_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [REWARD_REFER.QUERY_RANK_LIST_REQUEST]: (state, action) => state,
  [REWARD_REFER.QUERY_RANK_LIST_SUCCESS]: (state, action) => Object.assign({}, state, action.payload)
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'rewardRefer',
    reducerMap: {
      rewardReferState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
